import '.br{flex-shrink:0;}.ssr-plugin'
import '.bs{padding:1rem;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.ax{height:100%;}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.b5{background-color:transparent;}.ssr-plugin'
import '.g2{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import '.d9{position:sticky;}.ssr-plugin'
import '.g3{top:4rem;}.ssr-plugin'
import '.g4{z-index:7;}.ssr-plugin'
import '.af{background-color:var(--shades-white);}.ssr-plugin'
import '.g5{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.g6{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.cq{top:0;}.ssr-plugin'
import '.av{left:0px;}.ssr-plugin'
import '.aw{right:0px;}.ssr-plugin'
import '.g7{bottom:0px;}.ssr-plugin'
import '.du{z-index:9999;}.ssr-plugin'
import '.g8{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cp{justify-content:flex-end;}.ssr-plugin'
import '.bt{flex:1;}.ssr-plugin'
import '.ag{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="br bs a6 ax b4 b5 g2"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ac"
    >
      <div className="d9 g3 g4 af g5 v g6 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a2 cq av aw g7 du af g8 a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bs a cp g6"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bt ag">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
